import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import VisionSection from "./components/VisionSection";
import PortfolioSection from "./components/PortfolioSection";
import Footer from "./components/Footer";
import EqtosLanding from "./components/EqtosLanding";
import SEO from "./components/SEO";
import AnalyticsTracker from "./components/AnalyticsTracker";
import ErrorBoundary from "./components/ErrorBoundary";

const LandingPage = ({ lang, setLang }) => {
  return (
    <div className="min-h-screen bg-black">
      <SEO 
        title="Samanext | Venture Studio & Cognitive Software"
        description="Architecting the future of global trade and finance. We build high-impact AI solutions like Eqtos. Based in California, we incubate platforms that solve multi-billion dollar inefficiencies."
        image="https://images.unsplash.com/photo-1639322537228-f710d846310a?w=1200&h=630&fit=crop"
        url="https://samanext.com"
        locale={lang === 'es' ? 'es_ES' : 'en_US'}
      />
      <Header lang={lang} setLang={setLang} />
      <main>
        <HeroSection lang={lang} />
        <AboutSection lang={lang} />
        <VisionSection lang={lang} />
        <PortfolioSection lang={lang} />
      </main>
      <Footer lang={lang} />
    </div>
  );
};

function App() {
  const [lang, setLang] = useState('en');
  
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <div className="App">
          <BrowserRouter>
            <AnalyticsTracker />
            <Routes>
              <Route path="/" element={<LandingPage lang={lang} setLang={setLang} />} />
              <Route path="/eqtos" element={<EqtosLanding lang={lang} setLang={setLang} />} />
            </Routes>
          </BrowserRouter>
        </div>
      </HelmetProvider>
    </ErrorBoundary>
  );
}

export default App;
